import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as Coin } from "../../assets/images/svg/coin1.svg";
import nuvamaWealth from "../../assets/images/svg/nuvamaWealth.svg";
import withOthersTitle from "../../assets/images/svg/withOthersTitle.svg";
import noRecords from "../../assets/images/svg/noRecords.svg";
import infoIcon2 from "../../assets/images/svg/infoIcon2.svg";

import MonthwiseWealth from "../MonthwiseWealth/MonthwiseWealth";
import TotalWealthValue from "../TotalWealthValue/TotalWealthValue";
import NavButton from "../NavButton/NavButton";
import Modal from "../Modal";
import TotalPortfolioModal from "../../pages/Home/HomeContent/TotalPortfolioModal";
import {
  COMBINED,
  family_modal_title,
  homePageRoute,
  VIEW_INFINITY,
} from "../../utils/constants";
import ModalFamily from "../ModalFamily/ModalFamily";
import SelectNuvama from "../SelectNuvama/SelectNuvama";
import { observer } from "mobx-react-lite";
import {
  commaSeperated,
  displayUnit,
  getAsOfDate,
  getDisplayDate,
  getUsersOffshoreValue,
  logEvents,
  trackEvent,
} from "../../utils/functions";
import { useNavigate } from "react-router";
import UserStore from "../../store/UserStore";
import downArrowBlack from "../../assets/images/svg/downArrowBlack.svg";
import { getCookie } from "../../utils/cookie";
import PageHeading from "../PageHeading/PageHeading";

const DashWithNoDataMessage = ({
  message = "No data available",
  className,
}) => {
  return (
    <>
      <div className={className} aria-hidden="true">
        -
      </div>
      <div className="sr-only">{message}</div>
    </>
  );
};

const CashRow = ({ isNavigation = false, value, onClick, title, children }) => {
  return (
    <div className={`list_items`}>
      <div className="list_title">{title}</div>
      {value?.value && Number(value?.value) !== 0 ? (
        <>
          {" "}
          <div className="list_amt">
            <span className="amt">
              {value?.value ? commaSeperated(value?.value) : ""}
            </span>
            <span className="currency">{displayUnit(value?.value_type)}</span>
          </div>
          <div className="list_btn" onClick={onClick}>
            <NavButton />
          </div>
        </>
      ) : !isNavigation ? (
        children ? (
          children
        ) : (
          <div className="dashed_liabilities">-</div>
        )
      ) : (
        <>
          <div className="list_btn" onClick={onClick}>
            <NavButton />
          </div>
        </>
      )}
    </div>
  );
};

const TotalWealth = observer(() => {
  const [openFamilyModal, setOpenFamilyModal] = useState(false);
  const [openCashWorthModal, setCashWorthModal] = useState(false);
  const [hasDomesticAndOffshore, setHasDomesticAndOffshore] = useState(false); // true if client is having domestic and global investment

  const [modalKey, setModalKey] = useState("");
  const [selectedMember, setSelectedMember] = useState("0");
  const withNuvamaState = UserStore.withNuvama;
  const withOthersState = UserStore.withOthers;

  const lastFocusableElement = useRef(null);

  const navigate = useNavigate();

  const isInfinity =
    !!UserStore.portfolio?.clientPortfolio?.valuation?.infinity?.total_amount
      ?.actual_value;

  const portfolioData = JSON.parse(JSON.stringify(UserStore.portfolio));

  const getModalTitle = () => {
    if (modalKey === "unutilised")
      return {
        value: `${portfolioData?.clientPortfolio?.valuation?.unUtilisedCash?.amount?.value}`,
        name: "Unutilised Cash",
        unit: `${portfolioData?.clientPortfolio?.valuation?.unUtilisedCash?.amount?.value_type}`,
      };
    if (modalKey === "derivatives")
      return {
        value: `${portfolioData?.clientPortfolio?.derivatives?.amount?.value}`,
        name: "Derivatives",
        unit: `${portfolioData?.clientPortfolio?.derivatives?.amount?.value_type}`,
      };
    if (modalKey === "liabilities")
      return {
        value: `${portfolioData?.clientPortfolio?.liabilities?.amount?.value}`,
        name: "Liabilities",
        unit: `${portfolioData?.clientPortfolio?.liabilities?.amount?.value_type}`,
      };
  };

  const handleNavigation = () => {
    let Id = null;
    const familyId = UserStore.userData.family_id || getCookie("famid");
    const userId = UserStore.userData.user_id || getCookie("userid");

    trackEvent(VIEW_INFINITY);
    logEvents(VIEW_INFINITY);

    UserStore.getData === "fam" ? (Id = familyId) : (Id = userId);

    navigate(`/${homePageRoute}/subassetclassdetailshome/${Id}/fromHome`, {
      state: { from: "homeScreen", title: "Infinity Instruments" },
    });
  };

  const getNoRecords = () => {
    return (
      portfolioData?.clientPortfolioReturn?.current_value?.value &&
      Number(portfolioData?.clientPortfolioReturn?.current_value?.value) ===
        0 &&
      portfolioData?.clientPortfolioReturn?.invested_value?.value &&
      Number(portfolioData?.clientPortfolioReturn?.invested_value?.value) === 0
    );
  };

  const getCashList = () => {
    if (modalKey === "unutilised")
      return portfolioData?.clientPortfolio?.valuation?.unUtilisedCash
        .cashComponentList;
    if (modalKey === "derivatives")
      return portfolioData?.clientPortfolio?.derivatives?.cashComponentList;
    if (modalKey === "liabilities")
      return portfolioData?.clientPortfolio?.liabilities?.cashComponentList;
  };

  const handleWealth = () => {
    UserStore.populateHomeScreen();
  };

  useEffect(() => {
    if (UserStore.isHydrated) {
      setHasDomesticAndOffshore(getUsersOffshoreValue({}) === COMBINED);
    }
  }, [UserStore.isHydrated]);

  const dateComp = ({ title, date, alt, img }) => {
    return (
      <>
        {alt && <img className="logo_img" src={img} alt={alt} />}
        <div className="nuvama_date">
          <span className="date_title">{title}</span>
          <span className="title_date">
            {" "}
            as on{" "}
            {getDisplayDate(
              //  portfolioData?.clientPortfolioReturn?.as_of_date
              getAsOfDate(date),
            )}
          </span>
          <span className="date_title">
            {hasDomesticAndOffshore ? " (Domestic Investments Only)" : ""}{" "}
          </span>
        </div>
      </>
    );
  };

  const dateTile = ({ withNuvamaState, withOthersState, date, images }) => {
    return (
      <div className="with_container_first">
        <div
          style={{
            height: "25px",
          }}
          className={
            selectedMember !== "0" && true
              ? "with_container_first_sub first_sub_inifinity"
              : "with_container_first_sub first_sub_without_inifinity"
          }
        >
          {withNuvamaState && withOthersState ? (
            <>
              {dateComp({
                title: "Consolidated Portfolio",
                date: date,
              })}
            </>
          ) : withNuvamaState ? (
            <>
              {
                <>
                  {dateComp({
                    title: " With Nuvama Private",
                    date: date,
                    alt: "nuvama",
                    img: images.nuvamaWealth,
                  })}
                </>
              }
            </>
          ) : withOthersState ? (
            <>
              {
                <>
                  {dateComp({
                    title: "With Others",
                    date: date,
                    alt: "others",
                    img: images.withOthersTitle,
                  })}
                </>
              }
            </>
          ) : (
            <>
              {
                <>
                  {dateComp({
                    title: "Consolidated Portfolio",
                    date: date,
                  })}
                </>
              }
            </>
          )}
        </div>
      </div>
    );
  };

  const closeCashWorthModal = () => {
    setCashWorthModal(false);
    lastFocusableElement.current.focus();
  };

  return (
    <>
      <div className="main_container">
        <div className="total_wealth_nav">
          <div className="actual_nav">
            <div className="containt_title">
              <div className="logo1">
                {/* <img src={coin1} alt="lg" /> */}
                <Coin />
              </div>
              <PageHeading
                headingClass={"title1"}
                headingText={"Investment Summary"}
              />
            </div>{" "}
            <SelectNuvama
              type={"all"}
              loader={true}
              handleWealth={(title) => handleWealth(title)}
              setOpenFamilyModal={() => setOpenFamilyModal(true)}
              selectedMember={selectedMember}
              memberDropdownClass="analytics-members-dropdown"
              memberDropdownTextClass="analytics-members-dropdown-text"
              downArrowIcon={downArrowBlack}
              page={"home"}
            />
          </div>
        </div>
        {!getNoRecords() ? (
          <>
            {" "}
            <div
              className={
                !isInfinity
                  ? "first_row with_infinity_width"
                  : "first_row without_inifinity_width"
              }
            >
              <div className={"with_container"}>
                {dateTile({
                  withNuvamaState,
                  withOthersState,
                  date: portfolioData?.clientPortfolioReturn?.as_of_date,
                  images: {
                    nuvamaWealth,
                    withOthersTitle,
                  },
                })}

                <div
                  className={
                    isInfinity
                      ? "with_container_second with_container_second_justify"
                      : "with_container_second"
                  }
                >
                  <div
                    className={
                      isInfinity
                        ? "containers_first_div container_first_div_infiniy"
                        : "containers_first_div container_first_div_without_infiniy"
                    }
                  >
                    <div className="with_container_second_sub1">
                      <TotalWealthValue
                        title={"Current Value"}
                        amount={
                          portfolioData?.clientPortfolioReturn?.current_value
                            ?.value
                        }
                        unit={
                          portfolioData?.clientPortfolioReturn?.current_value
                            ?.value_type
                        }
                        isGreen={false}
                      />
                    </div>
                    <div className="with_container_second_sub2">
                      <TotalWealthValue
                        title={"Invested Value"}
                        amount={
                          portfolioData?.clientPortfolioReturn?.invested_value
                            ?.value
                        }
                        unit={
                          portfolioData?.clientPortfolioReturn?.invested_value
                            ?.value_type
                        }
                        isGreen={false}
                      />
                    </div>
                    <div className="with_container_second_sub3">
                      <TotalWealthValue
                        title={"Unrealised Gains (%)"}
                        amount={
                          portfolioData?.clientPortfolioReturn?.unrealised_gain
                            ?.amount.value
                        }
                        unit={
                          portfolioData?.clientPortfolioReturn?.unrealised_gain
                            ?.amount.value_type
                        }
                        percentage={
                          portfolioData?.clientPortfolioReturn?.unrealised_gain
                            ?.percentage
                        }
                        isGreen={
                          parseFloat(
                            portfolioData?.clientPortfolioReturn
                              ?.unrealised_gain?.amount.value,
                          ) < 0
                        }
                      />
                    </div>
                    <div className="with_container_second_sub4">
                      <TotalWealthValue
                        title={"Realised Gain"}
                        amount={
                          portfolioData?.clientPortfolioReturn?.realised_gain
                            ?.amount.value
                        }
                        unit={
                          portfolioData?.clientPortfolioReturn?.realised_gain
                            ?.amount.value_type
                        }
                        percentage={
                          portfolioData?.clientPortfolioReturn?.realised_gain
                            ?.percentage || undefined
                        }
                        isGreen={
                          parseFloat(
                            portfolioData?.clientPortfolioReturn?.realised_gain
                              ?.amount.value,
                          ) < 0
                        }
                      />
                    </div>
                    <div className="with_container_second_sub5">
                      <TotalWealthValue
                        title={"Total Returns (IRR)"}
                        percentage={
                          portfolioData?.clientPortfolioReturn?.irr
                            ? `${portfolioData?.clientPortfolioReturn?.irr}`
                            : "-"
                        }
                        amount={
                          portfolioData?.clientPortfolioReturn?.total_returns
                            ?.value
                        }
                        unit={
                          portfolioData?.clientPortfolioReturn?.total_returns
                            ?.value_type
                        }
                        infoLogo={infoIcon2}
                        TooltipContent={
                          <div className="irr_tip tip_align">
                            <h2>Total Returns</h2>
                            <p>
                              (Realised + Unrealised + Int/Div and Other Income)
                            </p>
                          </div>
                        }
                        isGreen={
                          parseFloat(
                            portfolioData?.clientPortfolioReturn?.irr,
                          ) < 0
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              {isInfinity && (
                <div className="infinity">
                  <div className="inifinity_title">
                    <div className="title">
                      Your financial assets also include{" "}
                    </div>
                    <NavButton onClick={handleNavigation} />
                  </div>
                  <div className="infinity_body">
                    <div className="infinity_body_title">
                      <div className="title">
                        <span>
                          {portfolioData?.clientPortfolio?.valuation?.infinity
                            ?.total_amount.value
                            ? commaSeperated(
                                portfolioData?.clientPortfolio?.valuation
                                  ?.infinity?.total_amount.value,
                              )
                            : ""}
                        </span>
                        <span className="span_unit">
                          {" "}
                          {displayUnit(
                            portfolioData?.clientPortfolio?.valuation?.infinity
                              ?.total_amount.value_type,
                          )}
                        </span>
                        <span> Invested in Infinity</span>
                      </div>
                    </div>
                    <div className="infinity_body_content">
                      <div className="content_1">
                        <span>
                          as on{" "}
                          {getDisplayDate(
                            portfolioData?.clientPortfolio?.valuation?.infinity
                              ?.instrumentPriceDate,
                          )}
                        </span>
                      </div>
                      <div className="content_2">INFINITY</div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="second_row">
              <div className="pl_snapshot snapshot-center">
                <div className="pl_snapshot_first">
                  <div className="pl_snapshot_first_sub">Your P&L Snapshot</div>
                </div>
                <div className="pl_snapshot_second">
                  {portfolioData?.clientPortfolio?.movementsList?.map(
                    (item, index, list) =>
                      item.duration === "THIS WEEK" ||
                      item.duration === "THIS MONTH" ||
                      item.duration === "THIS YEAR" ? (
                        <div
                          // className={
                          //   index !== 0 &&
                          //   index !==
                          //     portfolioData?.clientPortfolio?.movementsList
                          //       ?.length -
                          //       1
                          //     ? "pl_snapshot_second_sub2 add_padding"
                          //     : index === 0
                          //       ? "pl_snapshot_second_sub2 add_padding_right"
                          //       : index ===
                          //           portfolioData?.clientPortfolio
                          //             ?.movementsList?.length -
                          //             1
                          //         ? "pl_snapshot_second_sub2 add_padding_left"
                          //         : "pl_snapshot_second_sub2"
                          className={`pl_snapshot_second_sub2 add_padding${
                            index === 0
                              ? "_right"
                              : index === list?.length - 1
                                ? "_left"
                                : ""
                          }
                          `}
                        >
                          <MonthwiseWealth
                            period={item.duration}
                            percentage={item.gain_percentage}
                            amount={item.amount.value}
                            actualAmount={item.amount.actual_value}
                            unit={item.amount.value_type}
                            isNegative={
                              parseFloat(item.gain_percentage || 0) < 0
                            }
                            isAmtNegative={
                              parseFloat(item.amount.value || 0) < 0
                            }
                          />
                        </div>
                      ) : null,
                  )}
                </div>
              </div>

              <div className="unlisted_cash">
                {hasDomesticAndOffshore && (
                  <CashRow
                    isNavigation={true}
                    title={"Global"}
                    value={""}
                    onClick={() => {
                      // Navigate to global
                      navigate(`/portfolio`, { state: { from: "global" } });
                    }}
                  />
                )}
                <CashRow
                  title={"Unutilised cash worth"}
                  value={
                    portfolioData?.clientPortfolio?.valuation?.unUtilisedCash
                      ?.amount
                  }
                  onClick={() => {
                    setModalKey("unutilised");
                    setCashWorthModal(true);
                  }}
                >
                  {" "}
                  <DashWithNoDataMessage className="dashed_liabilities" />
                </CashRow>
                <CashRow
                  title={"Liabilities"}
                  value={portfolioData?.clientPortfolio?.liabilities?.amount}
                  onClick={() => {
                    setModalKey("liabilities");
                    setCashWorthModal(true);
                  }}
                >
                  {" "}
                  <DashWithNoDataMessage className="dashed_liabilities" />
                </CashRow>
                <CashRow
                  title={"Derivatives"}
                  value={portfolioData?.clientPortfolio?.derivatives?.amount}
                  onClick={() => {
                    setModalKey("derivatives");
                    setCashWorthModal(true);
                  }}
                >
                  <DashWithNoDataMessage className="derivatives_dahsed" />
                </CashRow>
              </div>

              {/* <div className="unlisted_cash">
                <div className="list_items list_border">
                  <div className="list_title">Unutilised cash worth</div>
                  {portfolioData?.clientPortfolio?.valuation?.unUtilisedCash
                    ?.amount?.value &&
                  portfolioData?.clientPortfolio?.valuation?.unUtilisedCash
                    ?.amount?.value !== "0.00" &&
                  portfolioData?.clientPortfolio?.valuation?.unUtilisedCash
                    ?.amount?.value !== "0" ? (
                    <>
                      <div className="list_amt">
                        <span className="amt">
                          {portfolioData?.clientPortfolio?.valuation
                            ?.unUtilisedCash?.amount?.value
                            ? commaSeperated(
                                portfolioData?.clientPortfolio?.valuation
                                  ?.unUtilisedCash?.amount?.value,
                              )
                            : ""}
                        </span>
                        <span className="currency unitFont">
                          {displayUnit(
                            portfolioData?.clientPortfolio?.valuation
                              ?.unUtilisedCash?.amount?.value_type,
                          )}
                        </span>
                      </div>
                      <div className="list_btn">
                        <NavButton
                          ariaLabel="View Unutilised Cash Worth Details"
                          onClick={(e) => {
                            lastFocusableElement.current = e.currentTarget;
                            setModalKey("unutilised");
                            setCashWorthModal(true);
                          }}
                        />
                      </div>
                    </>
                  ) : (
                    <DashWithNoDataMessage className="dashed_liabilities" />
                    //<div className="dashed_liabilities" aria-label="No data available" role="text">-</div>
                  )}
                </div>
                <div className="list_items list_border">
                  <div className="list_title">Liabilities</div>
                  {portfolioData?.clientPortfolio?.liabilities?.amount?.value &&
                  portfolioData?.clientPortfolio?.liabilities?.amount?.value !==
                    "0.00" ? (
                    <>
                      {" "}
                      <div className="list_amt">
                        <span className="amt">
                          {portfolioData?.clientPortfolio?.liabilities?.amount
                            ?.value
                            ? commaSeperated(
                                portfolioData?.clientPortfolio?.liabilities
                                  ?.amount?.value,
                              )
                            : ""}
                        </span>
                        <span className="currency">
                          {displayUnit(
                            portfolioData?.clientPortfolio?.liabilities?.amount
                              .value_type,
                          )}
                        </span>
                      </div>
                      <div className="list_btn">
                        <NavButton
                          ariaLabel="View Liabilities Details"
                          onClick={(e) => {
                            lastFocusableElement.current = e.currentTarget;
                            setModalKey("liabilities");
                            setCashWorthModal(true);
                          }}
                        />
                      </div>
                    </>
                  ) : (
                    <DashWithNoDataMessage className="dashed_liabilities" />
                    //<div className="dashed_liabilities" aria-label="No data available" role="text">-</div>
                  )}
                </div>
                <div className="list_items ">
                  <div className="list_title">Derivatives</div>
                  {portfolioData?.clientPortfolio?.derivatives?.amount
                    ?.value ? (
                    <>
                      <div className="list_amt">
                        <span className="amt">
                          {portfolioData?.clientPortfolio?.derivatives?.amount
                            ?.value
                            ? commaSeperated(
                                portfolioData?.clientPortfolio?.derivatives
                                  ?.amount?.value,
                              )
                            : ""}
                        </span>
                        <span className="currency">
                          {displayUnit(
                            portfolioData?.clientPortfolio?.derivatives?.amount
                              ?.value_type,
                          )}
                        </span>
                      </div>
                      <div className="list_btn">
                        <NavButton
                          ariaLabel="View Darivatives Details"
                          onClick={(e) => {
                            lastFocusableElement.current = e.currentTarget;
                            setModalKey("derivatives");
                            setCashWorthModal(true);
                          }}
                        />
                      </div>
                    </>
                  ) : (
                    <DashWithNoDataMessage className="derivatives_dahsed" />
                    //  <div className="derivatives_dahsed" aria-label="No data available" role="text">-</div>
                  )}
                </div>
              </div> */}
            </div>
          </>
        ) : (
          // no data screen for this whole component
          <div className={"with_container2"}>
            {dateTile({
              withNuvamaState,
              withOthersState,
              date: portfolioData?.clientPortfolioReturn?.as_of_date,
              images: {
                nuvamaWealth,
                withOthersTitle,
              },
            })}

            <div className="no_data_container">
              <img style={{ width: "fit-content" }} src={noRecords} alt="" />
              <p className="no_data_text">
                You do not have any assets with Nuvama at the moment
              </p>
            </div>
          </div>
        )}
      </div>

      <Modal
        onClose={() => setOpenFamilyModal(false)}
        open={openFamilyModal}
        title={family_modal_title}
        width={"810px"}
      >
        <ModalFamily
          setSelectedMember={(id) => setSelectedMember(id)}
          selectedMember={selectedMember}
          onClose={() => setOpenFamilyModal(false)}
        />
      </Modal>
      {modalKey && (
        <Modal
          onClose={closeCashWorthModal}
          width={"669px"}
          open={openCashWorthModal}
        >
          <TotalPortfolioModal
            data={getCashList()}
            titleKey={getModalTitle()}
            title={
              <p>
                You have {getModalTitle()?.name} worth{" "}
                <span style={{ fontFamily: "Roboto" }}>
                  {getModalTitle()?.value
                    ? commaSeperated(getModalTitle()?.value)
                    : ""}
                </span>
                <span style={{ fontSize: "21px" }}>
                  &nbsp;
                  {getModalTitle()?.unit === "lacs"
                    ? "L"
                    : getModalTitle()?.unit}
                </span>
              </p>
            }
            onClose={closeCashWorthModal}
          />
        </Modal>
      )}
    </>
  );
});

export default TotalWealth;
